import { Chat } from '../../types'
import { ChatFilters as ChatFiltersFromSet } from '../setChatFiltersAction/types'
import { ChatFilters } from './types'

export function getChatsWithUnreadMessages(chats: Chat[], status: 'chats_with_unread_messages') {
  if (status !== 'chats_with_unread_messages') return []
  return chats?.filter(chat => chat.unreadMessagesCount > 0) || []
}

export function buildChaFilters(chatFilters: ChatFiltersFromSet): ChatFilters {
  const hasPeriod = chatFilters.period && chatFilters.period.start && chatFilters.period.end
  const filters: ChatFilters = {}

  if (chatFilters.isFunnel) filters.isFunnel = true
  if (chatFilters.isUra) filters.isUra = true
  if (chatFilters.isGroup) filters.isGroup = true
  if (chatFilters.labels?.length) filters.labelIds = chatFilters.labels.map(label => label.value as string)
  if (chatFilters.campaigns?.length) {
    filters.campaignIds = chatFilters.campaigns.map(campaign => campaign.value.id)
  }
  if (hasPeriod) {
    filters.period = {
      start: chatFilters.period.start.getTime(),
      end: chatFilters.period.end.getTime()
    }
  }

  return filters
}
